import React, { useState } from 'react';
import { Layout } from 'antd';
import { InfoUsuario } from '@utils';
import Menu from './Menu';

const Sider = ({ siderProps, infoUsuario }) => {
  const [collapsed, setCollapsed] = useState(localStorage.getItem('collapsed') === 'true');
  const [broken, setBroken] = useState(false);

  const handleCollapse = (collapsed) => {
    setCollapsed(collapsed);
    localStorage.setItem('collapsed', collapsed);
  };

  const onBreakpoint = (broken) => {
    setBroken(broken);
    if (broken) handleCollapse(true);
  };

  const onCollapse = (collapsed, type) => {
    if (type === 'clickTrigger') {
      handleCollapse(collapsed);
    }
  };

  let siderWidth = 0;
  let zeroWidthTriggerStyle = { display: 'none' };
  if (InfoUsuario.hasUser(infoUsuario)) {
    siderWidth = siderProps ? siderProps.width : 250;
    zeroWidthTriggerStyle = null;
  }

  return (
    <Layout.Sider
      collapsed={collapsed}
      defaultCollapsed={false}
      collapsible
      breakpoint="lg"
      collapsedWidth={broken ? '0' : '80'}
      zeroWidthTriggerStyle={zeroWidthTriggerStyle}
      width={siderWidth}
      onBreakpoint={onBreakpoint}
      onCollapse={onCollapse}
    >
      <Menu infoUsuario={infoUsuario} collapsed={collapsed} />
    </Layout.Sider>
  );
};

export default Sider;
